/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/15/19
 * Time: 3:05 PM
 */
import React, {Component, createRef} from 'react';
import {MDBModal, MDBModalBody, MDBModalHeader} from "mdbreact";
import QrReader from 'react-qr-reader'
import '../../Reception/Dashboard/ScanQR/ScanQR.css'
import Details from "../../Reception/Dashboard/ScanQR/Details/Details";
import {Button as SementicBtn, Input} from "semantic-ui-react";
import {Col, Row} from "reactstrap";
import * as common from '../../../const/Common/CommonFunc';
import Cookies from "js-cookie";
import axios from "../../../axios/axios_visitortag";
import * as actionCreator from "../../../store/Action";
import {connect} from "react-redux";
import pass_icon from "../../../assets/img/recept_checkin/pass.svg";
import apiConfig from "../../../axios/axios_api_services";

class App extends Component {
  state = {
    result: null,
    ref_code: ''
  };

  toggle = () => {
  };

  handleScan = data => {
    if (data) {
      this.sendToBackend(data);

    }
  };
  handleError = err => {
    console.error(err)
  };

  handleChange = name => event => {
    clearTimeout(this.timeout);

    let value = event.target.value;
    this.setState({
      [name]: value
    });

    if(value.trim().length > 10){
      this.timeout = setTimeout(()=>{
        this.sendToBackend(value)
      }, 1000);
    }
  };

  sendRef = () => {
    let {ref_code} = this.state;
    if(ref_code.trim() === ""){
      common.notifyMessage("Please enter REF CODE")
    }else{
      this.sendToBackend(ref_code)
    }
  };

  sendToBackend = (value) => {
    // let {ref_code} = this.state;
    this.props.spinnerHandler(true);

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    let corporateId = this.props.usr_obj.corporates[0].corporateId;

    axios.get(apiConfig.CORPORATE_PRESHEDULED_MEETING_CREATE({corporateId:corporateId,refId:value}), {headers: headers})
      .then(response => {
        if (response.data.success) {
          if(response.data.error_code === 710){
            common.warningAlert(response.data.message, 1);

            let cards_list = this.props.all_available_card;
            cards_list.push({
              key: response.data.card.cardId,
              text: response.data.card.passId,
              value: response.data.card.cardId,
              image: {avatar: true, src: pass_icon},
            });
            this.props.receptionAllAvailableCardHandler(cards_list);
            this.setState({
              result: {
                isCard: true,
                meeting_pass_no: response.data.card.cardId,
                content: response.data.visitor
              }
            })
          }else {
            this.setState({
              result: {
                isCard: false,
                content: response.data.content
              }
            })
          }

        } else {
          common.warningAlert(response.data.message, 1)
        }
      })

      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.sendToBackend(value);
        }
      })
      .finally(fin =>{
        this.props.spinnerHandler(false);
      })
  };
  inputRefCode = createRef();
  componentDidMount() {
    this.inputRefCode.current.focus();
    this.getAllRequiredDetails();
  }
  getAllRequiredDetails = () => {
    this.props.callAllBuildings(this.props.usr_obj);
    this.getAvailableCards(this.props.usr_obj);
  };
  getAvailableCards = (obj, id) => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    let cards_list = [];
    axios.get(apiConfig.CORPORATE_ACTIVE_CARD(obj.corporates[0].corporateId), { headers: headers })
      .then(response => {
        this.props.spinnerHandler(false);
        if (response.data.success) {
          let cards = response.data.cards;

          if (cards.length !== 0) {
            cards.map((card, index) => {
              let data = {
                key: card.cardId,
                text: card.passId,
                value: card.cardId,
                image: { avatar: true, src: pass_icon },
              };
              cards_list.push(data)
            })
          } else {
            if (id !== 1) {
              this.noCardsAvailable()
            }
          }
        } else {
          this.noCardsAvailable();
        }
        this.props.receptionAllAvailableCardHandler(cards_list)
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAvailableCards(obj, id);
        } else {
          this.props.spinnerHandler(false);
        }
      });
  };
  render() {
    return (
      <div className={"qr-scan-none-modal-wrapper"}>
        {
          this.state.result === null ?
            <div className={"qr-scan-modal"}>
              <MDBModalHeader className={"title"} toggle={this.props.closeModal}>Scan QR Code</MDBModalHeader>

              <MDBModalBody style={{padding: '0px'}}>
                <Row className={"scan-qr-div"}>
                  <Col lg="10" md={"8"} sm={"8"} xs={"8"} className={"scan-qr-col8"}>
                    <Input
                      ref={this.inputRefCode}
                      focus={true}
                      // style={txtStyle}
                      className={"ref-qr-input"}
                      label={{tag: false, content: 'Ref Code'}}
                      labelPosition='left'
                      placeholder='Enter ref code'
                      value={this.state.ref_code}
                      onChange={this.handleChange('ref_code')}
                    />
                  </Col>
                  <Col lg="2" md={"4"} sm={"4"} xs={"4"} className={"search-visitor-col"}>
                    <SementicBtn className="px-5 search-visitor-btn"
                                 onClick={this.sendRef}>Search</SementicBtn>
                  </Col>
                </Row>

                <QrReader
                  delay={300}
                  onError={this.handleError}
                  onScan={this.handleScan}
                  style={{width: '100%'}}
                />

              </MDBModalBody>
            </div>
            :
            <MDBModal isOpen={true}  size="lg">
              <MDBModalHeader className={"title"} toggle={this.closeModal}>Meeting Details</MDBModalHeader>
              <MDBModalBody>
                <div>
                  <Details closeModal={this.closeModal} result={this.state.result}/>
                </div>
              </MDBModalBody>
            </MDBModal>
        }
      </div>
    );
  }
  closeModal = () => {
    this.setState({result:null})
    this.getAllRequiredDetails();
  }
}

const mapStateToProps = (state) => ({
  usr_obj: state.userReducer.user,
  all_available_card: state.reception_SheduleMeetingReducer.all_available_card,
});

const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    // all available cards

    callAllBuildings: (data) => dispatch(actionCreator.callAllBuildings(data)), // Get All Buildings Of Corporate
    receptionAllAvailableCardHandler: (data) => dispatch(actionCreator.receptionAllAvailableCardHandler(data))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
